
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Switch,
    FormControl,
    FormLabel,
    FormControlLabel,
    Dialog,
    DialogTitle,
    Divider,
    Slide,
    InputLabel,
    Select,
    Grid,
    Button,
    LinearProgress
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutTabModel,
        LayoutSectionModel,
        LayoutFieldModel,
        LookupFieldModel,
        ObjectModel,
        RecordModel,
        RecordFactory,
        LayoutRelatedListModel,
        LayoutCombinedRelatedListModel,
        FileInfoType} from '../../models/models';
import {PaginatorModel,
        PaginatorFactory,
        RelatedListConfigurationModel,
        RelatedListConfigurationFactory} from '../../models/modelsListConfiguration';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {CalendarDialogComponent} from "../../components/calendarDialog/CalendarDialog";
import {RelatedListComponent} from "./RelatedList";
import {CombinedRelatedListComponent} from "./CombinedRelatedList";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router";
import {setSelectedTabObject,
        getSelectedTabObject} from "../../app/globalLayoutSlice";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {getAppName, getObjectName, getRecordUuid } from "../../utils/helperRouter";
import {EmailFieldComponent} from "../fields/EmailField";
import {PhoneFieldComponent} from "../fields/PhoneField";
import {UrlFieldComponent} from "../fields/UrlField";
import {UUIDFieldComponent} from "../fields/UUIDField";
import {BigAutoFieldComponent} from "../fields/BigAutoField";
import {AutoIdentifierNameFieldComponent} from "../fields/AutoIdentifierNameField";
import {TextFieldComponent} from "../fields/TextField";
import {HtmlFieldComponent} from "../fields/HtmlField";
import {CodeTextFieldComponent} from "../fields/CodeTextField";
import {FormulaFieldComponent} from "../fields/FormulaField";
import {ProcedureFieldComponent} from "../fields/ProcedureField";
import {JsonFieldComponent} from "../fields/JsonField";
import {FileFieldComponent} from "../fields/FileField";
import {TextFieldEncryptedComponent} from "../fields/TextFieldEncrypted";
import {DecimalFieldComponent} from "../fields/DecimalField";
import {IntegerFieldComponent} from "../fields/IntegerField";
import {BooleanFieldComponent} from "../fields/BooleanField";
import {SelectFieldComponent} from "../fields/SelectField";
import {MultiSelectFieldComponent} from "../fields/MultiSelectField";
import {DateFieldComponent} from "../fields/DateField";
import {DateTimeFieldComponent} from "../fields/DateTimeField";
import {LookupFieldComponent} from "../fields/LookupField";
import {SlugFieldComponent} from "../fields/SlugField";
import {useSnackbar} from "notistack";

//SHIFT THIS AT SOME POINT TO OTHER ROUTINE
import { useAuth } from "../../hooks/useAuth";
import {retrieveRelatedRecords,
        purgeRecords as purgeRelatedRecords,
        purgePaginator as purgeRelatedPaginator} from "../../screens/object/relatedRecordsSlice";
import {retrieveRelatedRecords as retrieveCombinedRelatedRecords,
        selectRelatedRecords as selectCombinedRelatedRecords,
        selectIsFetching as selectIsFetchingCombinedRelatedRecords} from "../../screens/object/combinedRelatedRecordsSlice";
import {downloadFile as downloadFileApi} from "../../screens/record/recordSlice";
import {defaultRegistry} from "../../utils/defaultRegistry";
/*

COMPONENT FOR DISPLAYING RECORD FROM A SELECTED TAB

*/

export const LayoutSectionComponent: React.FC<{
  layoutSection: LayoutSectionModel,
  record: RecordModel,
  onChange: () => void;
}> = ({
  layoutSection,
  record,
  onChange
}) => {

  const styles = ContainerClasses();

  const dispatch = useDispatch<any>();

  let {appName, objectName, recordUuid} = useParams();
  const {accessToken, onInvalidToken} = useAuth();

  const [mutableRecord, setMutableRecord] = useState<RecordModel>(record);

//  const relatedRecords = useSelector(selectRelatedRecords);
//  const relatedListConfig = useSelector(selectRelatedListConfig);
  const combinedRelatedRecords = useSelector(selectCombinedRelatedRecords);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
      setMutableRecord(record);
  }, [record]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    layoutSection.layout_related_lists.map((thisList: LayoutRelatedListModel) => {
      const thisObjectName = getObjectName(objectName)
      const thisRecordUuid = getRecordUuid(recordUuid)
      const thisPaginator = null
      dispatch(purgeRelatedRecords(thisList.Uuid_sys))
      dispatch(purgeRelatedPaginator(thisList.Uuid_sys))
      dispatch(retrieveRelatedRecords(thisObjectName, thisRecordUuid, thisList, thisPaginator, accessToken, false, onInvalidToken));
    })
    layoutSection.layout_combined_related_lists.map((thisList: LayoutCombinedRelatedListModel) => {
        const thisObjectName = getObjectName(objectName)
        const thisRecordUuid = getRecordUuid(recordUuid)
        dispatch(retrieveCombinedRelatedRecords(thisObjectName, thisRecordUuid, thisList, accessToken, false, onInvalidToken));
    })
  }, [layoutSection]); // eslint-disable-line react-hooks/exhaustive-deps

  const selectRelatedRecord = (recordUuid: string, referencedObject: ObjectModel) => {
    const objectApiName = referencedObject.ApiName_sys
    const appApiName = getAppName(appName)
    navigate(`/${appApiName}/${objectApiName}/${recordUuid}`);
  }

  const navigate = useNavigate();
  const selectRecord = (layoutField: LayoutFieldModel) => {
    const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
    const uuidValue = mutableRecord.fields[fieldApiName].fieldValue.Uuid_sys;
    const objectApiName = layoutField.ReferencedField_sys.ReferencedObject_sys.ApiName_sys
    const appApiName = getAppName(appName)
    navigate(`/${appApiName}/${objectApiName}/${uuidValue}`);
  }

  const downloadFile = async(layoutField: LayoutFieldModel) => {
    const thisObjectName = getObjectName(objectName)
    const thisRecordUuid = getRecordUuid(recordUuid)
    const thisFieldApiName = layoutField.ReferencedField_sys.ApiName_sys;

    const message = await dispatch(downloadFileApi(thisObjectName, thisRecordUuid, thisFieldApiName, accessToken));
    if(message !=='success'){
       enqueueSnackbar(message, {
               variant: "error",
          });
    }
  }

  const formulaFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <FormulaFieldComponent
          layoutField={layoutField}
          value={thisValue}
        />
      </Grid>
     )
   }

  const procedureFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <ProcedureFieldComponent
          layoutField={layoutField}
          value={thisValue}
        />
      </Grid>
     )
   }


  const textFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <TextFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editTextField}
        />
      </Grid>
     )
   }

  const slugFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <SlugFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editSlugField}
        />
      </Grid>
     )
   }

  const htmlFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <HtmlFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editTextField}
        />
      </Grid>
     )
   }

  const codeTextFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <CodeTextFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editTextField}
        />
      </Grid>
     )
   }

  const jsonFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <JsonFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editJsonField}
        />
      </Grid>
     )
   }

  const fileFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <FileFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editFileField}
          onDownload={downloadFile}
        />
      </Grid>
     )
   }


  const uuidFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <UUIDFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editUuidField}
        />
      </Grid>
     )
   }

  const bigAutoFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <BigAutoFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editBigAutoField}
        />
      </Grid>
     )
   }

  const autoIdentifierNameFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <AutoIdentifierNameFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editAutoIdentifierNameField}
        />
      </Grid>
     )
   }

  const urlFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <UrlFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editUrlField}
        />
      </Grid>
     )
   }

  const emailFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <EmailFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editEmailField}
        />
      </Grid>
     )
   }

  const phoneFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <PhoneFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editPhoneField}
        />
      </Grid>
     )
   }

  const encryptedCharFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord);
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <TextFieldEncryptedComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editTextField}
        />
      </Grid>
     )
   }

  const decimalFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord)
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <DecimalFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editDecimalField}
        />
      </Grid>
     )
   }

  const integerFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord)
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <IntegerFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editIntegerField}
        />
      </Grid>
     )
   }

  const booleanFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord)
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <BooleanFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editBooleanField}
        />
      </Grid>
     )
   }

  const selectFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord)
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <SelectFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editSelectField}
        />
      </Grid>
    )
   }

  const multiSelectFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord)
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <MultiSelectFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editMultiSelectField}
        />
      </Grid>
    )
   }

  const dateFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord)
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <DateFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editDateField}
        />
      </Grid>
     )
   }

  const dateTimeFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord)
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <DateTimeFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onChange={editDateTimeField}
        />
      </Grid>
     )
   }

  const lookupFieldElement = (layoutField: LayoutFieldModel) => {
    const thisValue = getFormValue(layoutField, mutableRecord)
    return (
      <Grid item xs={12} md={6} key={layoutField.Uuid_sys}>
        <LookupFieldComponent
          layoutField={layoutField}
          value={thisValue}
          onSelect={selectRecord}
          onChange={editLookupField}
        />
      </Grid>
     )
   }

  const sortFunction = (layoutSectionA: LayoutSectionModel,
                        layoutSectionB: LayoutSectionModel) => {
    //sort layout sections by rank
    let sortIndex = 1
    layoutSectionA.Rank_sys > layoutSectionB.Rank_sys ? sortIndex = 1 : sortIndex=-1;
    return sortIndex
  }


  const editUuidField = (value: string, layoutField: LayoutFieldModel) => {}
  const editBigAutoField = (value: string, layoutField: LayoutFieldModel) => {}
  const editAutoIdentifierNameField = (value: string, layoutField: LayoutFieldModel) => {}

  const editTextField = (value: string, layoutField: LayoutFieldModel) => {

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
//       const value = event.target.value;
       mutableRecord.fields[fieldApiName].fieldValue=value;
       mutableRecord.fields[fieldApiName].fieldChanged=true;


       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editSlugField = (value: string, layoutField: LayoutFieldModel) => {

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       mutableRecord.fields[fieldApiName].fieldValue=value;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editFileField = (value: File, layoutField: LayoutFieldModel) => {
       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       const newFileInfo: FileInfoType = {url: null,
                                          filename: value.name,
                                          mimetype: null}
       mutableRecord.fields[fieldApiName].fieldValue=newFileInfo;
       mutableRecord.fields[fieldApiName].fieldChanged=true;
       mutableRecord.fields[fieldApiName].file=value;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();

  }

  const editJsonField = (value: string, layoutField: LayoutFieldModel) => {

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;

       mutableRecord.fields[fieldApiName].fieldValue=value;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editEmailField = (value: string, layoutField: LayoutFieldModel) => {

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       mutableRecord.fields[fieldApiName].fieldValue=value;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editPhoneField = (value: string, layoutField: LayoutFieldModel) => {

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       mutableRecord.fields[fieldApiName].fieldValue=value;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editUrlField = (value: string, layoutField: LayoutFieldModel) => {

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       mutableRecord.fields[fieldApiName].fieldValue=value;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }


  const editDecimalField = (value: string, layoutField: LayoutFieldModel) => {

      let numberValue = 0

      if(value === ""){
        numberValue = 0
      }
      else {
       numberValue = parseFloat(value);
      }

       const numberDigitsRight = layoutField.ReferencedField_sys.Scale_sys
       const numberDigitsLeft = layoutField.ReferencedField_sys.Precision_sys - numberDigitsRight
       const stepSize = 10**(-numberDigitsRight);
       const maxValue = 10**numberDigitsLeft - stepSize;

       if(isNaN(numberValue) || numberValue < -maxValue || numberValue > maxValue) {
         return
       }

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       mutableRecord.fields[fieldApiName].fieldValue=numberValue;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editIntegerField = (value: string, layoutField: LayoutFieldModel) => {

    //remove leading zeros
      let numberValue = 0

      if(value === ""){
        numberValue = 0
      }
      else {
       numberValue = parseInt(value);
      }

       if(isNaN(numberValue) || numberValue < 0) {
         return
       }

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       mutableRecord.fields[fieldApiName].fieldValue=numberValue;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }



  const editSelectField = (value: string, layoutField: LayoutFieldModel) => {

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       mutableRecord.fields[fieldApiName].fieldValue=value;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editMultiSelectField = (values: string[], layoutField: LayoutFieldModel) => {

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       const newValues = [...values]

       mutableRecord.fields[fieldApiName].fieldValue=newValues;
       mutableRecord.fields[fieldApiName].fieldChanged=true;
       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editBooleanField = (value: boolean, layoutField: LayoutFieldModel) => {

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       mutableRecord.fields[fieldApiName].fieldValue=value;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editDateField = (newDateValue: Date, layoutField: LayoutFieldModel) => {

       const newDateText = formatDate(newDateValue)

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       mutableRecord.fields[fieldApiName].fieldValue=newDateText;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editDateTimeField = (newDateValue: Date, layoutField: LayoutFieldModel) => {

       const newDateText = formatDatetime(newDateValue, {variant: 'A'})

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
       mutableRecord.fields[fieldApiName].fieldValue=newDateText;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       //get all fields that are depending on this current field
       //NOTE: for now, only the fields in the current section can be adapted
       const dependentFields = layoutSection.layout_fields.filter((thisField: LayoutFieldModel) => {

            if(thisField.ReferencedField_sys.DefaultValue_sys &&
               thisField.ReferencedField_sys.DefaultValue_sys.context &&
               thisField.ReferencedField_sys.DefaultValue_sys.context.depends_on &&
               Array.isArray(thisField.ReferencedField_sys.DefaultValue_sys.context.depends_on) &&
               thisField.ReferencedField_sys.DefaultValue_sys.context.depends_on.includes(layoutField.ReferencedField_sys.ApiName_sys)){
                 return true
            }
            return false
       })
       dependentFields.map((dependentField: LayoutFieldModel) => {
         try {
           //do nothing if there is no function defined
           if(dependentField.ReferencedField_sys.DefaultValue_sys.type !== 'frontend_function') return
           const thisFunctionName = dependentField.ReferencedField_sys.DefaultValue_sys.value
           if(!thisFunctionName) return
           const thisContext = dependentField.ReferencedField_sys.DefaultValue_sys.context
           const thisFunction = defaultRegistry.getFunction(thisFunctionName);
           //evaluate function
           let dependentValue = thisFunction(newDateValue, thisContext);
           if(dependentField.ReferencedField_sys.Type_sys === 'DateTimeField') dependentValue = formatDatetime(dependentValue, {variant: 'A'})
           const dependentFieldApiName = dependentField.ApiName_sys;
           mutableRecord.fields[dependentFieldApiName].fieldValue = dependentValue;
           mutableRecord.fields[dependentFieldApiName].fieldChanged = true;

           return
         } catch(error) {
           return
         }
       })


       setMutableRecord({
           ...mutableRecord
         })
      onChange();
  }

  const editLookupField = (newLookupRecord: RecordModel | null, layoutField: LayoutFieldModel) => {

       const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;

       const newLookupValue = new LookupFieldModel(
                                     newLookupRecord?.fields?.Id_sys?.fieldValue,
                                     newLookupRecord?.fields?.Uuid_sys?.fieldValue,
                                     newLookupRecord?.fields?.lookup_display_value?.fieldValue
                                   )

       mutableRecord.fields[fieldApiName].fieldValue=newLookupValue;
       mutableRecord.fields[fieldApiName].fieldChanged=true;

       setMutableRecord({
           ...mutableRecord
         })

      onChange();

  }



  const getFormValue = (layoutField: LayoutFieldModel, thisRecord: RecordModel | null) => {

    const fieldApiName = layoutField.ReferencedField_sys.ApiName_sys;
    const recordField = thisRecord?.fields[fieldApiName];


    if(layoutField.ReferencedField_sys.Type_sys === 'ForeignKey') return recordField?.fieldValue?.lookup_display_value;
    if(layoutField.ReferencedField_sys.Type_sys === 'OneToOneField') return recordField?.fieldValue?.lookup_display_value;
    if(layoutField.ReferencedField_sys.Type_sys === 'JSONField'){
      if(typeof(recordField?.fieldValue) === 'string') return recordField?.fieldValue
      return JSON.stringify(recordField?.fieldValue, null, 2)
    }

    return recordField?.fieldValue

  }



  return (

<>

   <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
             <Typography>
                    {layoutSection.Label_sys}
                 </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Grid
                  container
                  spacing={2}
                  sx={{pb: 2}}
                >
                 {layoutSection.layout_fields.map((layout_field) => {

                   if(layout_field.ReferencedField_sys.Type_sys === 'CharField' &&
                      layout_field.ReferencedField_sys.PicklistValues_sys === null){
                     return textFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'TextField' &&
                      layout_field.ReferencedField_sys.PicklistValues_sys === null){
                     return textFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'SlugField'){
                    return slugFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'CharField'){
                     return selectFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'HtmlField' &&
                      layout_field.ReferencedField_sys.PicklistValues_sys === null){
                     return htmlFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'CodeTextField' &&
                      layout_field.ReferencedField_sys.PicklistValues_sys === null){
                     return codeTextFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'BooleanField'){
                    return booleanFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'DateField'){
                    return dateFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'DateTimeField'){
                    return dateTimeFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'SlugField'){
                    return (<Box key={layout_field.Uuid_sys}>TODO: SlugField </Box>)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'TextField'){
                    return (<Box key={layout_field.Uuid_sys}>TODO: TextField </Box>)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'JSONField'){
                    return jsonFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'URLField'){
                    return (urlFieldElement(layout_field))
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'DecimalField'){
                    return decimalFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'IntegerField'){
                    return integerFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'BigIntegerField'){
                    return integerFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'EmailField'){
                    return emailFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'PhoneField'){
                    return phoneFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'ForeignKey'){
                    return lookupFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'OneToOneField'){
                    return lookupFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'EncryptedCharField'){
                    return encryptedCharFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'BigAutoField'){
                    return bigAutoFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'UUIDField'){
                    return uuidFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'AutoIdentifierNameField'){
                    return autoIdentifierNameFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'FileField'){
                    return fileFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'FormulaField'){
                    return formulaFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'ProcedureField'){
                    return procedureFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'MultiSelectField'){
                     return multiSelectFieldElement(layout_field)
                   }
                   else{
                    return (<Box key={layout_field.Uuid_sys}>TODO: {layout_field.ReferencedField_sys.Type_sys} </Box>)
                   }
                 })
               }
               </Grid>
               <Grid container spacing={1}>
               {layoutSection.layout_related_lists.map((this_list) => {
                 /*
                 let thisRelatedRecords: RecordModel[] = [];
                 if(this_list.Uuid_sys in relatedRecords){
                   thisRelatedRecords = relatedRecords[this_list.Uuid_sys];
                 }
                 let thisListConfig = new RelatedListConfigurationFactory().init()
                 if(this_list.Uuid_sys in relatedListConfig){
                   thisListConfig = relatedListConfig[this_list.Uuid_sys]
                 }*/
                   return (
                     <React.Fragment key={this_list.Uuid_sys}>
                        <Box sx={{width: "100%",
                                  border: 1,
                                  borderRadius: 5}}
                        >
                           <RelatedListComponent
                              layoutRelatedList = {this_list}
                              columns = {this_list.columns.map((column) => column)}
                              selectRecord={selectRelatedRecord}
                           />
                        </Box>
                        <Box sx={{height: 10}}>
                        </Box>
                      </React.Fragment>
                    )
               })}

               </Grid>
               <Grid container spacing={1}>
               {layoutSection.layout_combined_related_lists.map((this_list) => {

                 const layoutCombinedRelatedListUuid = this_list.Uuid_sys;
                 let thisCombinedRelatedRecords: RecordModel[] = [];
                 if(layoutCombinedRelatedListUuid in combinedRelatedRecords){
                   thisCombinedRelatedRecords = combinedRelatedRecords[layoutCombinedRelatedListUuid];
                 }
                   return (
                     <React.Fragment key={this_list.Uuid_sys}>
                        <Box sx={{width: "100%",
                                  border: 1,
                                  borderRadius: 5}}
                        >
                           <CombinedRelatedListComponent
                              layoutCombinedRelatedList = {this_list}
                              columns = {this_list.columns.map((column) => column)}
                              records = {thisCombinedRelatedRecords}
                              loadMoreRecords={() => {}}
                              selectRecord={() => {}}
                           />
                        </Box>
                        <Box sx={{height: 10}}>
                        </Box>
                      </React.Fragment>
                    )
               })}

               </Grid>
              </AccordionDetails>
            </Accordion>

    </>
  );

};
